<nav class="navbar" #nav pnDetectScrollDown="hide">
    <div class="nav-container">
        <a class="nav-logo" routerLink="/">
            <img ngSrc="/assets/images/logo.png" alt="Logo" priority width="96" height="96" />
        </a>

        <div class="flex flex-col gap-1 ml-2">
            <h3 class="font-lato-bold text-base gap-1 font-bold text-primary-700 leading-tight whitespace-nowrap">NGÔI NHÀ PHƯƠNG NAM</h3>
            <a href="tel:{{ commonConfig.hotline }}" class="flex items-center text-red-500 hover:text-red-700 transition-colors duration-200 font-lato-semibold text-lg font-semibold">
                <span>Hotline: {{ commonConfig.hotline }}</span>
            </a>
        </div>

        <ul class="nav-menu max-[1120px]:!hidden">
            @for (item of listMenu; track $index) {
                <li
                    class="nav-menu-item nav-time-line"
                    (click)="handleClick(item, $index)"
                    [ngClass]="{
                        'menu-item--active': activeIndex === $index,
                    }"
                    pnInkBar="indicator"
                    activeClass="indicator--active"
                >
                    <p class="whitespace-nowrap">{{ item.title }}</p>
                    <div class="indicator"></div>
                </li>
            }
        </ul>

        <div class="justify-end gap-1 flex-row-center mb:gap-4 max-[1120px]:grow">
            <button
                class="language-btn nav-time-line mb:!hidden"
                pnButton
                size="tiny"
                link
                status="primary"
                rounded="xs"
                aria-label="language button"
                [pnOverlay]="languageDropdown"
                [overlayPosition]="overlayLanguageDropdownPosition"
                blockScroll
            >
                <img
                    [ngSrc]="selectedLanguage.imageUrl"
                    loading="lazy"
                    width="96"
                    height="96"
                    alt=""
                    srcset=""
                    class="h-[21.6px] w-[32.34px]"
                />
            </button>

            @if (!session) {
                <div class="gap-3 flex-row-center mb:!hidden">
                    <button
                        pnButton
                        outline
                        status="primary"
                        class="auth-btn nav-time-line relative font-lato-heavy !text-sm !font-extrabold"
                        i18n="@@auth.buttons.login"
                        (click)="openAuthDialog('sign-in')"
                    >
                        Đăng nhập
                    </button>
                    <button
                        pnButton
                        status="primary"
                        class="auth-btn nav-time-line font-lato-heavy !text-sm !font-extrabold"
                        i18n="@@auth.buttons.register"
                        (click)="openAuthDialog('register')"
                    >
                        Đăng ký
                    </button>
                </div>
            } @else {
                <pn-notification class="flex mb:order-1" />
                <div
                    class="nav-time-line cursor-pointer gap-3 rounded px-2 py-1 flex-row-center hover:bg-primary-100 mb:!hidden"
                    [pnOverlay]="userMenuRef"
                    [overlayPosition]="overlayUserDropdownPosition"
                    blockScroll
                >
                    <img
                        [ngSrc]="session.ProfilePictureUrl || 'assets/images/avatar-default.png'"
                        loading="lazy"
                        width="96"
                        height="96"
                        class="size-8 rounded-full"
                        alt=""
                    />

                    <h3 class="font-lato-bold text-base font-bold text-primary-700">
                        {{ session.FullName }}
                    </h3>

                    <svg-icon src="assets/icons/chevron-down.svg" svgClass="size-6" />
                </div>

                <ng-template #userMenuRef let-overlay="overlay">
                    <ul class="menu-list">
                        <li
                            class="menu-item"
                            (click)="handleNavigateToPath('account/information', overlay)"
                        >
                            <svg-icon src="assets/icons/user.svg" svgClass="size-6" />
                            <span i18n="@@auth.menu-items.account-info">Thông tin tài khoản</span>
                        </li>
                        <li
                            class="menu-item"
                            (click)="handleNavigateToPath('account/orders', overlay)"
                        >
                            <svg-icon
                                src="assets/icons/document-justify-right-3.svg"
                                svgClass="size-6"
                            />
                            <span i18n="@@auth.menu-items.account-order">Đơn hàng của tôi</span>
                        </li>
                        <li class="menu-item">
                            <svg-icon src="assets/icons/ticket-discount.svg" svgClass="size-6" />
                            <span i18n="@@auth.menu-items.account-refund">Quản lý hoàn tiền</span>
                        </li>
                        <li class="menu-item" (click)="handleLogout()">
                            <svg-icon src="assets/icons/logout.svg" svgClass="size-6" />
                            <span i18n="@@auth.menu-items.account-logout">Đăng xuất</span>
                        </li>
                    </ul>
                </ng-template>
            }
            <button
                class="nav-time-line flex-center mb:order-last mb:!flex tl:order-last min-[1120px]:hidden"
                pnButton
                size="tiny"
                link
                status="primary"
                rounded="sm"
                aria-label="menu button"
                [pnOverlay]="menu"
                blockScroll
                (overlayOpenChange)="overlayOpenChange($event)"
                overlayType="sideBarRight"
                id="menu-overlay"
            >
                <svg-icon src="/assets/icons/menu.svg" svgClass="size-8" />
            </button>
        </div>
    </div>

    @if (router.url === '/policy' || router.url === '/about-us') {
        <div class="border-t border-neutral-03">
            <div
                class="pn-container flex items-center justify-between bg-neutral-01 py-2 mb:hidden"
            >
                <div class="flex items-center gap-8">
                    <!-- <span
                        i18n="@@about-us.menu.hotel"
                        class="hidden font-lato-bold text-sm font-bold text-tab"
                    >
                        Khách sạn
                    </span>
                    <a
                        href="/news"
                        i18n="@@about-us.menu.news"
                        class="font-lato-bold text-sm font-bold text-tab"
                    >
                        Tin tức
                    </a> -->
                    <a
                        href="/about-us"
                        i18n="@@about-us.menu.introduce"
                        class="font-lato-bold text-sm font-bold text-tab"
                    >
                        Giới thiệu
                    </a>
                    <a
                        href="/contact-us"
                        i18n="@@about-us.menu.contact"
                        class="font-lato-bold text-sm font-bold text-tab"
                    >
                        Liên hệ
                    </a>
                </div>
                <div class="flex items-center gap-1 max-lg:hidden">
                    <svg-icon src="/assets/icons/phone-icon.svg" />
                    <span class="font-lato-bold text-sm font-bold text-neutral-07">
                        Hotline:
                        <span class="ml-1 font-lato font-normal">{{ commonConfig.hotline }}</span>
                    </span>
                </div>
            </div>
        </div>
    }
</nav>

<ng-template #languageDropdown>
    <ul class="dropdown">
        @for (item of languageOptions; track $index) {
            <li
                class="dropdown-item"
                (click)="changeLanguage(item)"
                [ngClass]="{ selected: selectedLanguage.code === item.code }"
            >
                <img [src]="item.imageUrl" alt="" srcset="" class="h-[21.6px] w-[32.34px]" />
                {{ item.title }}
            </li>
        }
    </ul>
</ng-template>

<ng-template #menu let-overlay="overlay">
    <div class="sidebar-container">
        <div class="text-right">
            <button pnButton icon size="tiny" (click)="handleClosePopup('menu-overlay')">
                <svg-icon
                    src="/assets/icons/close.svg"
                    svgClass="size-8"
                    class="icon:fill-neutral-04"
                />
            </button>
        </div>

        <div class="auth" [ngClass]="{ 'items-center !gap-0 !py-6': session }">
            @if (!session) {
                <button
                    pnButton
                    outline
                    status="primary"
                    class="z-20 font-lato-heavy !text-base !font-extrabold"
                    i18n="@@auth.buttons.login"
                    (click)="openAuthDialog('sign-in'); handleClosePopup('menu-overlay')"
                >
                    Đăng nhập
                </button>
                <button
                    pnButton
                    status="primary"
                    class="z-20 font-lato-heavy !text-base !font-extrabold"
                    i18n="@@auth.buttons.register"
                    (click)="openAuthDialog('register'); handleClosePopup('menu-overlay')"
                >
                    Đăng ký
                </button>
            } @else {
                <button
                    class="flex flex-col items-center"
                    (click)="showUserMenu.set(!showUserMenu())"
                >
                    <img
                        [src]="session.ProfilePictureUrl || 'assets/images/avatar-default.png'"
                        class="size-20 rounded-full"
                        alt=""
                    />

                    <h3 class="mt-3 text-center font-lato-bold text-lg font-bold text-primary-700">
                        {{ session.FullName }}
                    </h3>
                </button>

                <button
                    pnButton
                    status="primary"
                    class="mt-4 w-full justify-center gap-2 font-lato-bold !text-base font-bold flex-row-center"
                    outline
                    (click)="handleLogout(); handleClosePopup('menu-overlay')"
                >
                    <svg-icon
                        src="assets/icons/logout.svg"
                        svgClass="size-5"
                        class="icon:fill-primary-500"
                    />
                    <span i18n="@@auth.menu-items.account-logout">Đăng xuất</span>
                </button>
            }

            <svg-icon class="absolute bottom-0 left-0 z-10" src="/assets/icons/nav-ticket.svg" />
            <svg-icon class="absolute bottom-0 left-0" src="/assets/icons/nav-vector.svg" />
            <svg-icon class="absolute bottom-0 right-0" src="/assets/icons/nav-vector-121.svg" />
            <svg-icon class="absolute right-0 top-0" src="/assets/icons/nav-layer-1.svg" />
            <svg-icon class="absolute right-0 top-0" src="/assets/icons/nav-isolation-mode.svg" />
        </div>

        <div class="relative grow overflow-hidden">
            <ul
                class="menu w-full"
                *ngIf="showUserMenu()"
                @showHideMenu
                (@showHideMenu.start)="animationStarted($event)"
                (@showHideMenu.done)="animationCompleted($event)"
            >
                <li
                    class="menu-item"
                    (click)="handleNavigateToPath('account/information', overlay)"
                >
                    <svg-icon src="assets/icons/user.svg" svgClass="size-6" />
                    <span i18n="@@auth.menu-items.account-info">Thông tin tài khoản</span>
                </li>
                <li class="menu-item" (click)="handleNavigateToPath('account/orders', overlay)">
                    <svg-icon src="assets/icons/document-justify-right-3.svg" svgClass="size-6" />
                    <span i18n="@@auth.menu-items.account-order">Đơn hàng của tôi</span>
                </li>
                <li class="menu-item">
                    <svg-icon src="assets/icons/ticket-discount.svg" svgClass="size-6" />
                    <span i18n="@@auth.menu-items.account-refund">Quản lý hoàn tiền</span>
                </li>
            </ul>
            <div
                *ngIf="!showUserMenu()"
                class="w-full"
                @showHideMenu
                (@showHideMenu.start)="animationStarted($event)"
                (@showHideMenu.done)="animationCompleted($event)"
            >
                <ul class="menu">
                    @for (item of listMenu; track $index) {
                        <li
                            class="menu-item"
                            [ngClass]="{ active: activeIndex === $index }"
                            (click)="handleClick(item, $index); handleClosePopup('menu-overlay')"
                        >
                            <svg-icon [src]="item.icon" svgClass="size-6" />

                            {{ item.title }}
                        </li>
                    }
                </ul>

                <div class="pn-divider my-3"></div>

                <button
                    class="language-btn !px-4 !py-3 !font-lato-bold !text-base !font-bold"
                    pnButton
                    link
                    rounded="xs"
                    status="basic"
                    aria-label="language button"
                    [pnOverlay]="_isMobile ? languagePopup : languageDropdown"
                    [overlayType]="_isMobile ? 'sideBarBottom' : 'dropdown'"
                    id="language-menu-overlay"
                    (overlayOpenChange)="overlayOpen($event)"
                >
                    <img
                        [src]="selectedLanguage.imageUrl"
                        alt=""
                        srcset=""
                        class="h-[16px] w-[24px]"
                    />
                    {{ selectedLanguage.title }}
                </button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #languagePopup>
    <div class="rounded-t-[20px] bg-neutral-01">
        <div class="justify-between border-b border-neutral-03 p-4 flex-row-center">
            <h3 class="font-lato-bold text-xl font-bold text-neutral-07" i18n="@@common.language">
                Ngôn ngữ
            </h3>
            <button pnButton icon size="tiny" (click)="handleClosePopup('language-menu-overlay')">
                <svg-icon src="/assets/icons/close.svg" svgClass="size-6" />
            </button>
        </div>

        <ul class="flex flex-col">
            @for (item of languageOptions; track $index) {
                <li
                    class="border-l-4 border-l-transparent py-3 pl-3 font-lato-medium text-base font-medium"
                    [ngClass]="{
                        '!border-l-primary-500 bg-primary-100':
                            item.code === selectedLanguageTemp.code,
                    }"
                    (click)="selectedLanguageTemp = item"
                >
                    {{ item.title }}
                </li>
            }
        </ul>

        <div class="border-t border-t-neutral-03 px-4 py-3">
            <button
                pnButton
                size="large"
                class="w-full"
                [disabled]="selectedLanguage === selectedLanguageTemp"
                (click)="changeLanguage(selectedLanguageTemp)"
                i18n="@@common.buttons.select"
            >
                Chọn
            </button>
        </div>
    </div>
</ng-template>
